var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2164 7.5678C10.3337 7.68048 10.3996 7.83329 10.3996 7.99262C10.3996 8.15195 10.3337 8.30475 10.2164 8.41743L6.6757 11.8166C6.61796 11.874 6.5489 11.9197 6.47253 11.9512C6.39617 11.9827 6.31404 11.9993 6.23094 12C6.14783 12.0007 6.06542 11.9855 5.9885 11.9553C5.91158 11.925 5.84169 11.8804 5.78293 11.824C5.72416 11.7676 5.67769 11.7005 5.64622 11.6267C5.61475 11.5528 5.59891 11.4737 5.59963 11.3939C5.60036 11.3141 5.61762 11.2353 5.65042 11.162C5.68323 11.0887 5.73091 11.0224 5.79069 10.9669L8.88884 7.99262L5.79069 5.0183C5.67668 4.90498 5.61359 4.7532 5.61502 4.59565C5.61644 4.4381 5.68227 4.2874 5.79831 4.17599C5.91436 4.06458 6.07134 4.00139 6.23544 4.00002C6.39955 3.99865 6.55765 4.05922 6.6757 4.16867L10.2164 7.5678Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.9033342f85b21576385f7fd901d443a2.svg";
export { ForwardRef as ReactComponent };